<div>

	<InputWalletAddress
		inputWalletAddress={mainObj.inputWalletAddress}
		transactionHistories={mainObj.transactionHistories}
		on:checkAddress={checkedAddress}
	/>
	
	{#if mainObj.transactionHistories.length > 0 }

		<SelectPlay mainObj={mainObj}/>
		<TransactionHistories
			transactionHistories={mainObj.transactionHistories}
		/>
	{/if}

	<Usage/>

</div>

<script>
import { onMount } from "svelte";	
import SelectPlay from "./SelectPlay.svelte";
import InputWalletAddress from "./InputWalletAddress.svelte";
import TransactionHistories from "./TransactionHistories.svelte";
import Usage from "./Usage.svelte";
import { writable } from "svelte/store";

	const d = document;

	const mainObj = {
		inputWalletAddress: "",
		transactionHistories: [],

		transactionFullHash : "",
		transactionFullHashToUpper : "",
		
		toneJsObj: {
			fullHash: "",
		},
	}

	// 子 ⇒ 親伝達
	const checkedAddress = (event) => {
		mainObj.inputWalletAddress   = event.detail.inputWalletAddress;
		mainObj.transactionHistories = event.detail.transactionHistories;
		makeFullHash(mainObj.transactionHistories);
		// console.log(mainObj);
	}
	// transactiion history から fullhash生成
	function makeFullHash(historiesArr){
		let fullHash = "";
		historiesArr.forEach( history =>{
			
			const fromAddress  = history.from;
			const toAddress    = history.to;
			const hash         = history.hash;
			const blockHash    = history.blockHash;

			const eachFullHash = fromAddress+toAddress+hash+blockHash;
			fullHash += eachFullHash;
		});

		mainObj.transactionFullHash        = fullHash;
		mainObj.transactionFullHashToUpper = fullHash.toUpperCase();
	}

</script>